export default class PolicyHelper{
    public static getPolicyFromRoute(route:string):string{
        // special case for providerWorker-page:
        if (route.match(/\/providers\/:?\w+/gm)?.some(()=>true)) return "Providers.View";

        switch(route){
            case "/users":
            case "/usersAdditional":
            case "/users/":
                return "Users.View";
            case "/plants":
            case "/plants/":
                return "Plants.View";
            case "/forms/reports":
            case "/forms/reports/":
                return "Forms.View";
            case "/settings":
            case "/settings/":
                return "Settings.View";
            case "/providers":
            case "/providers/":
                return "Providers.View";
            default:
                return "";
        }
    }
}